<template>
  <div class="data-grid-input-multiline">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    :title="title"
                    width="420px"
                    custom-class="data-grid-input-multiline-dialog">
      <div class="header">
        <div class="label theme-text">每个匹配条件之间使用换行进行分隔</div>
        <div class="extra">条件计数：<span class="theme-text">{{inputs.length}}</span></div>
      </div>
      <div class="main-cont">
        <el-input v-model="input"
                  size="mini"
                  type="textarea"
                  placeholder="请输入内容"></el-input>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   @click="handleApply">确认输入</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">取消操作</el-button>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from './DataGridDialog'
export default {
  name: 'DataGridInputMultiline',
  components: {
    DataGridDialog
  },
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    divider: {
      type: String,
      default: ' '
    }
  },
  data () {
    return {
      visible: false,
      input: ''
    }
  },
  computed: {
    inputs () {
      let input = this.input || ''
      return input.split('\n')
        .map(txt => txt.trim())
        .filter(txt => !!txt)
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleClose () {
      this.visible = false
    },
    parseInput () {
      if (this.value) {
        this.input = this.value.split(this.divider).join('\n')
      } else {
        this.input = ''
      }
    },
    handleApply () {
      this.$emit('input', this.inputs.join(this.divider))
      this.$nextTick(() => this.handleClose())
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.parseInput()
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-input-multiline {
    display: inline-block;
  }
  .data-grid-input-multiline-dialog {
    & > .el-dialog__body {
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px 0;
        & > .label {
          font-size: 12px;
        }
        & > .extra {
          font-size: 12px;
        }
      }
      .main-cont {
        padding: 10px 15px 15px;
        .el-textarea {
          & > .el-textarea__inner {
            height: 360px;
          }
        }
      }
      .footer {
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
